import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const GetOrganizationById = {
  name: 'GetOrganizationById',
  state: {
    loading: false,
    error: '',
    data: {}, // Stores organization details by ID
  },
  reducers: {
    fetchRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },
    fetchSucceeded(state, payload) {
      return {
        ...state,
        loading: false,
        data: payload,
        error: '',
      };
    },
    fetchFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
    clearData(state) {
      return {
        ...state,
        data: {},
        error: '',
      };
    },
  },
  effects: (dispatch) => ({
    async fetchOrganizationById({ organizationId, silent = false }) {
      try {
        this.fetchRequested();
        const response = await http.get(`savvy/organization/${organizationId}`);
        this.fetchSucceeded(response.data.data);

        if (!silent) {
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'success',
              message: 'Organization details fetched successfully!',
              show: true,
            },
          });
        }
      } catch (err) {
        this.fetchFailed(err.response?.data?.error || err.message || 'Failed to fetch organization details');
        if (!silent) {
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'error',
              message: responseMessageHandler.show(err.response?.data?.error || err.message || 'Failed to fetch organization details'),
              show: true,
            },
          });
        }
      }
    },
    clearFetchedData() {
      this.clearData();
    },
  }),
};

export default GetOrganizationById;

